import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Button } from "antd";
import { LoginOutlined, HomeOutlined } from "@ant-design/icons";
import {
	getCurrentUserProfile,
	hasStoredSession,
} from "../utilities/AuthService";
import NotificationBell from "./NotificationBell";

const Header = () => {
	const [userName, setUserName] = useState("");
	const [loading, setLoading] = useState(true);
	const navigate = useNavigate();
	const location = useLocation();

	// Don't show header on login/logout pages
	const isAuthPage =
		location.pathname === "/login" ||
		location.pathname === "/logout";

	useEffect(() => {
		if (!isAuthPage) {
			fetchUserName();
		}
	}, [isAuthPage]);

	const fetchUserName = async () => {
		// 로그인하지 않은 사용자는 프로필을 가져오지 않음
		if (!hasStoredSession()) {
			setUserName("");
			setLoading(false);
			return;
		}

		try {
			const profile = await getCurrentUserProfile();
			setUserName(profile.name || "사용자");
		} catch (error) {
			console.error("Error fetching user profile:", error);
			setUserName("");
		} finally {
			setLoading(false);
		}
	};

	const handleLogin = () => {
		navigate("/login");
	};

	if (isAuthPage) {
		return null;
	}

	const isLoggedIn = hasStoredSession();

	const handleHomeClick = () => {
		navigate("/");
	};

	return (
		<div className="app-header">
			<div className="app-header__content">
				<div className="app-header__brand">
					<Button
						type="default"
						icon={<HomeOutlined />}
						onClick={handleHomeClick}
						className="app-header__home-button">
						홈
					</Button>
					<div className="app-header__welcome">
						{loading
							? "로딩 중..."
							: isLoggedIn && userName
								? `${userName}님 환영합니다.`
								: ""}
					</div>
				</div>
				{isLoggedIn && (
					<div className="app-header__actions">
						<NotificationBell />
					</div>
				)}
				{!isLoggedIn && (
					<Button
						type="primary"
						icon={<LoginOutlined />}
						onClick={handleLogin}
						className="app-header__login-button">
						로그인
					</Button>
				)}
			</div>
		</div>
	);
};

export default Header;
